const styles = theme => ({
  filterModal: {
    paddingTop: '0px !important',
  },
  resetButton: {
    textTransform: 'none',
    padding: '12px',
  },
  searchButtonHolder: {
    position: 'fixed',
    bottom: '0',
    left: '0',
    right: '0',
    background: '#fff',
    padding: '16px',
    borderTop: '3px solid #EBEEF3',
    zIndex: '1021',
    '& button': {
      width: '100%',
      borderRadius: '0px',
      padding: '0.65em 3em',
    },
  },
  redButton: {
    background: theme.palette.primary.main,
    textTransform: 'none',

    '&:hover': {
      background: theme.palette.primary.main,
      opacity: '0.7',
    },
    '& svg': {
      marginRight: theme.spacing(1),
    },
  },
  searchButton: {
    fontSize: '14px',
    padding: '1em 3em',
    flexShrink: '0',
  },
  filterListContainer: {
    overflow: 'auto',
    maxHeight: 'calc(100vh - 155px)',
  },
  filterListDetailsContainer: {
    overflow: 'auto',
    height: '92vh',
  },
  filterList: {
    borderBottom: '8px solid #EBEEF3',
    '& div': {
      '& span': {
        fontSize: '14px',
      },
    },
  },
  filterListHidden: {
    display: 'none',
  },
  filterListItemDisabled: {
    background: theme.palette.primary.borderColor,
    color: theme.palette.primary.darkGrey,
  },
  filterListItemHidden: {
    display: 'none',
  },
  filterRadio: {
    borderBottom: '8px solid #EBEEF3',
    padding: '8px 0px',
    '& label': {
      marginLeft: '0',
      marginRight: '0',
      justifyContent: 'space-between',
      padding: '3px 12px 3px 16px',
      '& span': {
        fontSize: '14px',
      },
      '& input:checked + div': {
        color: theme.palette.primary.main,
      },
      '& input:checked + svg': {
        color: '#1FCACC',
      },
    },
    '& $filterRadioItem': {
      borderBottom: '1px solid #EBEEF3',
    },
    '& $filterRadioItemNoBorder': {
      borderBottom: 'none',
    },
  },
  filterRadioItem: {},
  filterRadioItemNoBorder: {},
  radioSwitchRoot: {
    width: 36,
    height: 24,
    padding: 0,
    margin: theme.spacing(1),
  },
  radioSwitchBase: {
    padding: 1,
    '&$radioChecked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $radioTrack': {
        backgroundColor: '#CED1D6',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $radioThumb': {
      color: '#CED1D6',
      border: '6px solid #fff',
    },
  },
  radioChecked: {},
  radioThumb: {
    width: 22,
    height: 22,
  },
  radioTrack: {
    borderRadius: '0px',
    border: '1px solid #CED1D6',
    backgroundColor: '#CED1D6',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  radioMessage: {
    border: '1px solid #CED1D6',
    padding: '8px',
    color: '#8C9099',
    borderRadius: '0 10px 10px 10px',
    fontSize: '12px',
    width: 'calc(100% - 32px)',
    margin: '12px auto 8px',
    display: 'flex',
    alignItems: 'flex-start',
    lineHeight: '1.4',
    position: 'relative',
    '& svg': {
      color: '#CED1D6',
      marginRight: '4px',
      fontSize: '18px',
    },
  },
  messageTriangleLeft: {
    width: '0',
    height: '0',
    borderTop: '10px solid transparent',
    borderLeft: '10px solid #CED1D6',
    borderBottom: '0 solid transparent',
    position: 'absolute',
    left: '-1px',
    top: '-10px',
    borderRadius: '0px',
    '&:after': {
      content: "''",
      width: '0',
      height: 0,
      borderTop: '8px solid transparent',
      borderRight: '8px solid transparent',
      borderBottom: '8px solid #fff',
      position: 'absolute',
      bottom: '0',
      right: '1px',
      borderRadius: '0px',
    },
  },
  filterPillsListContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '0px 15px',
  },
  filterPillsList: {
    display: 'flex',
    overflow: 'auto',
    flexGrow: '1',
    '& span': {
      fontSize: '12px',
      fontWeight: '500',
    },
    '& $filterPillsListItem': {
      padding: '4px 0px',
      textAlign: 'center',
      border: '1px solid #1FCACC',
      boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.2)',
      borderRadius: '0px',
      margin: '0 2px',
      width: '60px',
      '&:hover': {
        background: '#1C999B',
        color: '#fff',
      },
    },
  },
  filterPillsListItem: {},
  filterPillsListItemSelected: {
    background: '#1C999B',
    color: '#fff',
  },
  filterLeaseFields: {
    marginBottom: '24px',
  },
  plotField: {
    padding: '16px',
  },

  filterCheckBoxes: {
    borderBottom: '8px solid #EBEEF3',
    padding: '8px 0px',
  },

  filterCheckBoxItem: {
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '0',
    padding: '3px 12px 3px 16px',
    '&:not(:last-child)': {
      borderBottom: '1px solid #EBEEF3',
    },
    '& > span:first-of-type': {
      '&.Mui-checked': {
        color: '#1FCACC !important',
      },
    },
    '& > span:last-of-type': {
      fontSize: '14px',
    },
  },

  '@media (min-width: 960px)': {
    filterPillsListContainer: {
      padding: '0',
    },
    filterPillsListItem: {
      '& span': {
        fontSize: '14px',
      },
    },
  },
});

export default styles;
